import { API, graphqlOperation } from "aws-amplify"
import {
	GET_NOTIFICATION,
	CLEAR_NOTIFICATION,
	SEEN_NOTIFICATION,
	SUBSCRIPTION_NOTIFICATION,
	GET_CHECK_NOTI
} from "../ActionTypes"
import { getNotification } from "../graphql/queries"
import { updateSeenNotification } from "../graphql/mutation"

export const get_notification = (user_id, next_token) => ({
	type: GET_NOTIFICATION,
	payload: API.graphql(graphqlOperation(getNotification(user_id, next_token)))
})
export const seen_notification = (notification_id) => ({
	type: SEEN_NOTIFICATION,
	payload: API.graphql(
		graphqlOperation(updateSeenNotification(notification_id))
	)
})

export const subscription_notification = (data) => ({
	type: SUBSCRIPTION_NOTIFICATION,
	payload: data
})
export const clear_notification = () => ({
	type: CLEAR_NOTIFICATION
})

export const get_check_noti = (data) => ({
	type: GET_CHECK_NOTI,
	payload: data
})
